// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageContainer_JOS6d {
  background-color : white;
  display : inline-block;
  white-space : nowrap;
  padding : 8px;
  height : 118px;
  width : 160px;
  margin-right : 4px;
  border : 1px solid rgba(206, 214, 222, 1);
  border-radius : 2px;
}

.image_jtRhu {
  height : 100%;
  width : 100%;
  object-fit : fill;
}

.buttonContainer_Iu5K9 {
  width: 116px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/imageCapture/ImageCapture.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".imageContainer {\n  background-color : white;\n  display : inline-block;\n  white-space : nowrap;\n  padding : 8px;\n  height : 118px;\n  width : 160px;\n  margin-right : 4px;\n  border : 1px solid rgba(206, 214, 222, 1);\n  border-radius : 2px;\n}\n\n.image {\n  height : 100%;\n  width : 100%;\n  object-fit : fill;\n}\n\n.buttonContainer {\n  width: 116px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageContainer": `imageContainer_JOS6d`,
	"image": `image_jtRhu`,
	"buttonContainer": `buttonContainer_Iu5K9`
};
export default ___CSS_LOADER_EXPORT___;
